import React from 'react'
import { NavLink } from 'react-router-dom'
import './Sidebar.css'

const Sidebar = (props) => (
  <div className='sidebar'>
    <div className='sidebar__header'>
      <p>{props.user}</p>
      <p><span>Administrador</span></p>
    </div>
    <div className='sidebar__nav'>
      <ul>
        <li>
          <NavLink
            to='/'
            end
            className={({ isActive }) => isActive ? 'current' : ''}
          ><i className='icon'>home</i><span>Inicio</span></NavLink>
        </li>
        <li>
          <NavLink
            to='/add'
            className={({ isActive }) => isActive ? 'current' : ''}
          ><i className='icon'>add</i><span>Crear quiniela</span></NavLink>
        </li>
        <li>
          <NavLink
            to='/edit'
            className={({ isActive }) => isActive ? 'current' : ''}
          ><i className='icon'>create</i><span>Administrar quiniela</span></NavLink>
        </li>
        <li>
          <NavLink
            to='/view'
            className={({ isActive }) => isActive ? 'current' : ''}
          ><i className='icon'>visibility</i><span>Consultar quiniela</span></NavLink>
        </li>
      </ul>
    </div>
  </div>
)

export default Sidebar
